.nav {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 50;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  align-items: center;
  height: calc(var(--nav-h) + var(--safe-b));
  padding-bottom: var(--safe-b);
  background: rgb(0 0 0 / 0.92);
  backdrop-filter: blur(20px) saturate(1.4);
  border-top: 1px solid var(--border);
}

.immersive {
  background: rgb(0 0 0 / 0.96);
  border-top-color: rgb(255 255 255 / 0.06);
}

.tab {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3px;
  color: var(--text-3);
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.01em;
  padding: 6px 0;
  transition: color var(--t-fast);
}

.tab:hover {
  color: var(--text-2);
}

.active {
  color: var(--text);
}

.active .label {
  font-weight: 800;
}

.iconWrap {
  position: relative;
  display: grid;
  place-items: center;
  height: 26px;
}

.badge {
  position: absolute;
  top: -1px;
  right: -4px;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: var(--accent);
  box-shadow: 0 0 0 2px var(--bg);
}

.create {
  display: grid;
  place-items: center;
}

.createInner {
  display: grid;
  place-items: center;
  width: 52px;
  height: 36px;
  border-radius: 12px;
  background: var(--accent);
  color: var(--accent-ink);
  box-shadow: 0 0 0 1px rgb(var(--accent-rgb) / 0.3), 0 6px 22px rgb(var(--accent-rgb) / 0.28);
  transition: transform var(--t-fast) var(--ease-spring);
}

.create:active .createInner {
  transform: scale(0.92);
}

.create:hover .createInner {
  transform: translateY(-1px);
}
